module.exports = __webpack_public_path__ + "img/modal.c0b9f670.png";